<template>
  <v-container fluid class="fill-height d-block">
    <div class="pa-2 fill-height d-flex flex-column">
      <div class="businesses-searches">
        <v-form
          @submit.prevent="filtersSubmission()"
          class="d-flex align-center mb-3 flex-column flex-sm-row justify-sm-space-between"
        >
          <div class="d-flex justify-between flex-wrap">
            <v-autocomplete
              v-model="filtersObj.userId"
              :items="usernamesList.allItems"
              item-value="id"
              item-text="username"
              prepend-inner-icon="mdi-magnify"
              :label="
                $t('panel.businesses.businessesList.searchBoxesForm.userName')
              "
              class="theme-custom-input input-search user-name"
              outlined
              hide-details
              clearable
              dense
              @change="getBusinessNames"
              :loading="usernamesList.autocompleteListLoading"
              @focus="
                inputSearchCheck($event, service, 'usernamesList', 'username')
              "
              @keyup="inputSearch($event, service, 'usernamesList', 'username')"
              @paste="inputSearch($event, service, 'usernamesList', 'username')"
              @click:clear="
                inputSearch($event, service, 'usernamesList', 'username')
              "
            >
              <!--              <template v-slot:selection="{ item }">-->
              <!--                <span class="gray12&#45;&#45;text pa-0 ma-0">{{ item.username }}</span>-->
              <!--              </template>-->
              <!--                            <template v-slot:item="{ active, item, attrs, on }">-->
              <!--                              <template>-->
              <!--                                <v-list-item v-on="on" #default>-->
              <!--                                  <span class="gray12&#45;&#45;text">{{ item.username }}</span>-->
              <!--                                </v-list-item>-->
              <!--                              </template>-->
              <!--                            </template>-->
              <template v-slot:append-item>
                <div
                  v-intersect.quiet="intersectUsernameList"
                  class="ms-4"
                  v-if="
                    !usernamesList.moreItemsLoading &&
                      usernamesList.displayMoreItem
                  "
                >
                  ...
                </div>
                <v-progress-circular
                  v-else-if="usernamesList.moreItemsLoading"
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                  class="d-block mx-auto"
                />
              </template>
            </v-autocomplete>
            <transition mode="out-in" name="route">
              <v-autocomplete
                v-if="filtersObj.userId"
                v-model="filtersObj.businessId"
                :items="businessNamesList.allItems"
                item-value="id"
                item-text="businessName"
                prepend-inner-icon="mdi-magnify"
                :label="
                  $t(
                    'panel.businesses.businessesList.searchBoxesForm.businessName'
                  )
                "
                class="theme-custom-input input-search business-name"
                outlined
                hide-details
                clearable
                dense
                :loading="businessNamesList.autocompleteListLoading"
                @focus="
                  inputSearchCheck(
                    $event,
                    merchantService,
                    'businessNamesList',
                    'businessName',
                    'userId'
                  )
                "
                @keyup="
                  inputSearch(
                    $event,
                    merchantService,
                    'businessNamesList',
                    'businessName',
                    'userId'
                  )
                "
                @paste="
                  inputSearch(
                    $event,
                    merchantService,
                    'businessNamesList',
                    'businessName',
                    'userId'
                  )
                "
                @click:clear="
                  inputSearch(
                    $event,
                    merchantService,
                    'businessNamesList',
                    'businessName',
                    'userId'
                  )
                "
              >
                <template v-slot:append-item>
                  <div
                    v-intersect.quiet="intersectBusinessList"
                    class="ms-4"
                    v-if="
                      !businessNamesList.moreItemsLoading &&
                        businessNamesList.displayMoreItem
                    "
                  >
                    ...
                  </div>
                  <v-progress-circular
                    v-else-if="businessNamesList.moreItemsLoading"
                    :size="20"
                    :width="2"
                    color="primary"
                    indeterminate
                    class="d-block mx-auto"
                  />
                </template>
              </v-autocomplete>
            </transition>
            <v-autocomplete
              v-model="filtersObj.businessTypeId"
              :items="businessTypesList.allItems"
              item-value="businessTypeId"
              item-text="businessTypeName"
              prepend-inner-icon="mdi-magnify"
              :label="
                $t(
                  'panel.businesses.businessesList.searchBoxesForm.businessCategory'
                )
              "
              class="theme-custom-input input-search select-search business-type"
              outlined
              hide-details
              clearable
              dense
              :loading="businessTypesList.autocompleteListLoading"
              @focus="
                inputSearchCheck(
                  $event,
                  merchantType,
                  'businessTypesList',
                  'name'
                )
              "
              @keyup="
                inputSearch($event, merchantType, 'businessTypesList', 'name')
              "
              @paste="
                inputSearch($event, merchantType, 'businessTypesList', 'name')
              "
              @click:clear="
                inputSearch($event, merchantType, 'businessTypesList', 'name')
              "
            >
              <template v-slot:append-item>
                <div
                  v-intersect.quiet="intersectBusinessTypesList"
                  class="ms-4"
                  v-if="
                    !businessTypesList.moreItemsLoading &&
                      businessTypesList.displayMoreItem
                  "
                >
                  ...
                </div>
                <v-progress-circular
                  v-else-if="businessTypesList.moreItemsLoading"
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                  class="d-block mx-auto"
                />
              </template>
            </v-autocomplete>

            <!--            <v-autocomplete-->
            <!--              prepend-inner-icon="mdi-magnify"-->
            <!--              class="theme-custom-input input-search select-search crypto"-->
            <!--              v-model="filtersObj.businessesCategory"-->
            <!--              :items="businessesCategoryItems"-->
            <!--              outlined-->
            <!--              :label="-->
            <!--                $t('panel.transactionPage.cashIns.searchBoxesForm.crypto')-->
            <!--              "-->
            <!--              hide-details-->
            <!--              dense-->
            <!--              clearable-->
            <!--            />-->
          </div>
          <div
            class="d-flex justify-space-around align-center align-content-center align-self-sm-end form-buttons"
          >
            <v-btn color="primary" class="ma-3" type="submit">
              {{ $t("panel.businesses.businessesList.searchBoxesForm.submit") }}
            </v-btn>
            <v-btn outlined color="primary" @click="resetFilters">{{
              $t("panel.businesses.businessesList.searchBoxesForm.reset")
            }}</v-btn>
          </div>
        </v-form>
      </div>
      <v-data-table
        fixed-header
        :headers="$t('panel.businesses.businessesList.table.header')"
        :items="tableData"
        item-key="id"
        :loading="loading"
        loading-text="Loading... Please wait"
        :page.sync="filtersObj.page"
        :items-per-page="filtersObj.size"
        hide-default-footer
        @page-count="pageCount = $event"
        :class="shortList"
      >
        <template v-slot:item.businessName="{ item }">
          <router-link
            :to="{
              name: 'gateways',
              params: { businessId: item.id }
            }"
          >
            {{ item.businessName }}
          </router-link>
        </template>
        <template v-slot:item.businessesCategory="{ item }">
          {{ item.businessType.businessTypeName }}
        </template>
        <template v-slot:item.commission="{ item }">
          <v-btn
            text
            color="transparent"
            height="21"
            @click="commissionModalAction(item)"
            class="d-block"
          >
            <span
              v-if="item.contractType === 'DEAL'"
              class="font-regular-14 primary--text text-decoration-underline"
            >
              {{ +item.commission }}%
            </span>
            <span
              v-else
              class="font-regular-14 primary--text text-decoration-underline"
            >
              {{
                $t("panel.businesses.businessesList.table.fixedAmount.default")
              }}
            </span>
          </v-btn>
          <v-btn
            v-if="item.contractType === 'DEAL'"
            text
            color="transparent"
            height="21"
            @click="setDefaultCommission(item)"
            class="d-block"
          >
            <span class="font-regular-14 info--text text-decoration-underline">
              {{
                $t(
                  "panel.businesses.businessesList.table.fixedAmount.setDefault"
                )
              }}
            </span>
          </v-btn>
        </template>
        <template v-slot:item.insertDate="{ item }">
          <div class="text-no-wrap">{{ item.insertDate | $renderDate }}</div>
        </template>
        <template v-slot:item.lastModifyDate="{ item }">
          <div class="text-no-wrap">
            {{ item.lastModifyDate | $renderDate }}
          </div>
        </template>
      </v-data-table>
      <div v-if="tableData.length" class="text-center pt-2">
        <v-pagination
          v-model="filtersObj.page"
          :length="totalPages"
          :total-visible="7"
          prev-icon="< Back"
          next-icon="Next >"
          class="pagination"
          @input="filtersSubmission(true)"
        />
      </div>
    </div>
    <v-dialog v-model="commissionModal" max-width="470px">
      <v-btn icon :ripple="false" @click="commissionModal = false">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>

      <v-form ref="form" @submit.prevent="submitCommission" class="pa-6 pt-1">
        <v-text-field
          v-model="commissionPercentage"
          :rules="rules"
          v-separator="{ dot: true }"
          required
          :label="$t('panel.businesses.businessesList.commissionModal.label')"
          filled
          dense
          class="theme-custom-input fill-width commission-modal-input"
        >
        </v-text-field>

        <v-btn
          color="primary"
          class="py-6 font-semiBold-16 mt-1"
          depressed
          block
          :loading="submitLoading"
          type="submit"
        >
          {{ $t("panel.businesses.businessesList.commissionModal.submit") }}
        </v-btn>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import renderDate from "@/mixins/renderDate";
import setFiltersQueries from "@/mixins/setFilters&Queries";
import autocompleteListLazyLoading from "@/mixins/autocompleteListLazyLoading";
import { merchantService } from "@/services";

export default {
  name: "business-list",
  mixins: [renderDate, setFiltersQueries, autocompleteListLazyLoading],
  data() {
    return {
      totalPages: 1,
      pageCount: 0,
      loading: false,
      shortList: false,
      filtersObj: {
        userId: null,
        businessId: null,
        businessTypeId: null,
        page: 1,
        size: 10
      },
      tableFilters: [] || "",
      tableData: [],
      commissionModal: false,
      commissionPercentage: "",
      submitLoading: false,
      rules: [
        v =>
          +v <= 5 ||
          this.$t("panel.businesses.businessesList.commissionModal.notValid")
      ],
      chosenMerchantId: ""
    };
  },
  async mounted() {
    await this.$setFiltersFromQuery();
    await this.filtersSubmission(true);
    if (this.filtersObj.userId) {
      this.businessNamesList.extraKey = this.filtersObj.userId;
      await this.getUserInfo();
    }
    if (this.filtersObj.businessTypeId) {
      await this.getBusinessTypeInfo();
    }
  },
  computed: {},
  methods: {
    setDefaultCommission(item) {
      merchantService.setDefaultCommission({ merchantId: item.id }).then(() => {
        this.filtersSubmission(true);
      });
    },
    commissionModalAction(item) {
      this.commissionModal = true;
      const input = document.querySelector(".commission-modal-input input");
      if (item.contractType === "DEAL") {
        this.commissionPercentage = item.commission;
        if (input) {
          input.value = item.commission;
        }
      } else {
        this.commissionPercentage = "";
        if (input) {
          input.value = "";
        }
      }
      this.chosenMerchantId = item.id;
    },
    submitCommission() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.submitLoading = true;
      merchantService
        .commissionPercentage({
          commission: +this.commissionPercentage,
          merchantId: +this.chosenMerchantId
        })
        .then(() => {
          this.filtersSubmission(true);
          this.commissionModal = false;
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    getBusinessNames() {
      this.filtersObj.businessId = "";
      this.businessNamesList.extraKey = this.filtersObj.userId;
      this.businessNamesList.allItems = [];
    },
    resetFilters() {
      for (let key in this.filtersObj) {
        this.filtersObj[key] = null;
      }
      this.filtersObj.page = 1;
      this.filtersObj.size = 10;
      this.filtersSubmission();
    },
    async filtersSubmission(paginationButton) {
      await this.loadData(this.$setQueryFromFilters(paginationButton));
    },
    async loadData(filters) {
      this.loading = true;
      await merchantService
        .getAllMerchant(filters)
        .then(response => {
          this.tableData = response.data.data.content;
          const tableDataLength = this.tableData.length;
          if (tableDataLength < 5 && tableDataLength > 0) {
            if (tableDataLength === 1) {
              this.shortList = "short-list-one-item";
            } else this.shortList = "short-list";
          } else this.shortList = "";
          this.totalPages = response.data.data.totalPages;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "List";
</style>
